import { DATE_TIME_FORMAT_REG_EXP } from "utils/datetime";

export const coPayFormSchema = [
  {
    id: "id",
    dataType: "integer",
    shownOnForm: false,
    label: "ID",
    value: 0,
    fieldType: "textfield",
  },
  {
    id: "code",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Co-Pay Code",
    value: "",
    isRequired: true,
    maxChar: 50,
    fieldType: "textfield",
    pattern: /^[a-zA-Z0-9\-\_\s\(\)\,\.\']+$/,
    patternMessage: "Invalid code. Use letters, numbers, - or _",
  },
  {
    id: "policyItemId",
    label: "Policy Item",
    fieldType: "autocomplete",
    shownOnForm: true,
    width: "60%",
    isRequired: true,
    valueKey: "id",
    textValue: "label",
    remoteUrl: "/api/policy-items/search-list",
    onSearch: (query, deps) => {
      deps.onSearchPolicyItems(query);
    },
    options: (deps) => deps.policyItems || [],
    loading: (deps) => deps.policyItemsLoading,
    onInputChange: (searchValue, deps) => {
      if (deps.onSearchPolicyItems) {
        deps.onSearchPolicyItems(searchValue);
      }
    },
  },
  {
    id: "description",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Description",
    value: "",
    isRequired: true,
    fieldType: "textfield",
  },
  {
    id: "fixedAmountByBeneficiary",
    dataType: "number",
    shownOnForm: true,
    width: "60%",
    label: "Fixed Amount",
    value: 0,
    isRequired: true,
    fieldType: "textfield",
  },
  {
    id: "status",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Status",
    value: "Active",
    isRequired: true,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "Active", label: "Active" },
      { value: "Inactive", label: "Inactive" },
    ],
  },
  {
    id: "policyTypeIds",
    dataType: "Array",
    shownOnForm: true,
    isRequired: false,
    label: "Applicable Schemes",
    value: [],
    fieldType: "autocomplete",
    textValue: "label",
    valueKey: "id",
    multiple: true,
    onSearch: (query, deps) => {
      if (deps.onSearchPolicyTypes && query.length >= 3) {
        deps.onSearchPolicyTypes(query);
      }
    },
    onInputChange: (searchValue, deps) => {
      if (deps.onSearchPolicyTypes && searchValue.length >= 3) {
        deps.onSearchPolicyTypes(searchValue);
      }
    },
    options: ({ policyTypes }) => policyTypes || [],
  },
  // -------- NEW: hospitalsIds (multiselect) --------
  {
    id: "hospitalIds",
    dataType: "Array",
    shownOnForm: true,
    isRequired: false,
    label: "Hospitals",
    value: [],
    fieldType: "autocomplete",
    textValue: "label",
    valueKey: "id",
    multiple: true,
    onSearch: (query, deps) => {
      if (deps.onSearchHospitals && query.length >= 3) {
        deps.onSearchHospitals(query);
      }
    },
    onInputChange: (searchValue, deps) => {
      if (deps.onSearchHospitals && searchValue.length >= 3) {
        deps.onSearchHospitals(searchValue);
      }
    },
    options: ({ hospitals }) => hospitals || [],
  },
  /*
  {
    id: "hospitalIds",
    label: "Assigned Hospitals",
    fieldType: "dynamicList",
    shownOnForm: true,
    isRequired: false,
    columns: [
      {
        id: "hospitalId",
        label: "Hospital",
        type: "autocomplete",
        isRequired: true,
        optionsKey: "hospitals", // Pulled from deps
        valueKey: "id",
        textValue: "label",
        composeLabel: (option) => `${option.code} (${option.name})`,
        width: 500,
        remoteUrl: "/api/hospitals/search-list", // New prop for independent fetching
        onSearch: (query, deps) => {
          deps.onSearchHospitals(query);
        },
        options: (deps) => deps.hospitals || [],
        loading: (deps) => deps.hospitalsLoading,
        onInputChange: (searchValue, deps) => {
          if (deps.onSearchHospitals) {
            deps.onSearchHospitals(searchValue);
          }
        },
        /*
        onAfterValueUpdate: (value, deps, currentData) => {
          deps.onTerminalSelected(value, currentData);
        },
        
      },
    ],
  },
  */
];

export const coPayRecord = {
  id: null,
  code: "",
  description: "",
  benefit: "",
  fixedAmountByBeneficiary: 0,
  status: "active",
  policyItemId: null,
  policyTypeIds: [],
  hospitalIds: [],
};
